/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WidgetSubmitResponse
 */
export interface WidgetSubmitResponse {
    /**
     * 
     * @type {number}
     * @memberof WidgetSubmitResponse
     */
    claimId: number | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitResponse
     */
    claimNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof WidgetSubmitResponse
     */
    status: WidgetSubmitResponseStatusEnum;
}


/**
 * @export
 */
export const WidgetSubmitResponseStatusEnum = {
    Created: 'created',
    Replayed: 'replayed',
    Accepted: 'accepted'
} as const;
export type WidgetSubmitResponseStatusEnum = typeof WidgetSubmitResponseStatusEnum[keyof typeof WidgetSubmitResponseStatusEnum];


/**
 * Check if a given object implements the WidgetSubmitResponse interface.
 */
export function instanceOfWidgetSubmitResponse(value: object): value is WidgetSubmitResponse {
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function WidgetSubmitResponseFromJSON(json: any): WidgetSubmitResponse {
    return WidgetSubmitResponseFromJSONTyped(json, false);
}

export function WidgetSubmitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetSubmitResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimId': json['claimId'],
        'claimNumber': json['claimNumber'],
        'status': json['status'],
    };
}

export function WidgetSubmitResponseToJSON(json: any): WidgetSubmitResponse {
    return WidgetSubmitResponseToJSONTyped(json, false);
}

export function WidgetSubmitResponseToJSONTyped(value?: WidgetSubmitResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'claimNumber': value['claimNumber'],
        'status': value['status'],
    };
}

